import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import StepModal from "./StepModal";
import { APENFTOrders, initApprove } from "sherry-test-js-1";
import zhCN from "antd/es/date-picker/locale/zh_CN";
import enUS from "antd/es/date-picker/locale/en_US";

import { Input, Select, Form, Button, Modal, DatePicker } from "antd";
import Emitter from "../eventBus.js";
import { setAccount, setChain, setBalance } from "../actions/app";
import { t } from "../utils/i18n";
import { enquireScreen } from "enquire-js";
import { getMetadata } from "../common/api";
import BigNumber from "bignumber.js";
import { apiConfig } from "../config";

import TRX from "../images/trx.svg";
import WTRX from "../images/wtrx.svg";
import USDD from "../images/usdd.png";
import USDT from "../images/usdt.png";
import Fee from "../images/fee.png";

dayjs.extend(customParseFormat);

const imgMap = [
  { icon: TRX, label: "TRX" },
  { icon: WTRX, label: "WTRX" },
  { icon: USDD, label: "USDD" },
  { icon: USDT, label: "USDT" },
];
const { Option } = Select;

let isMobile;

enquireScreen((b) => {
  isMobile = b;
  console.log("isMobile", isMobile);
});
const toFixed = (value, length = 4, isCeil = false) => {
  try {
    if (value === undefined || isNaN(value)) {
      return "--";
    } else {
      if (isCeil) {
        return (
          Math.ceil(
            new BigNumber(value)
              .multipliedBy(new BigNumber(Math.pow(10, length)))
              .toNumber()
          ) / Math.pow(10, length)
        );
      } else {
        return (
          Math.floor(
            new BigNumber(value)
              .multipliedBy(new BigNumber(Math.pow(10, length)))
              .toNumber()
          ) / Math.pow(10, length)
        );
      }
    }
  } catch (e) {
    console.log(e);
  }
};

class SellModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInstalled: true,
      isLogin: true,
      priceHelp: null,
      priceStatus: null,
      price: null,
      dateHelp: null,
      dateStatus: null,
      date: null,
      assetData: null,
      cueCurrency: "TRX",
      sdkQuery: null,
      step: 0,
      stepVisible: false,
      stepError: false,
      curImageMap: imgMap,
    };
  }

  componentDidMount() {
    Emitter.on("showSellModal", (params) => {
      const { assetData, sdkQuery } = params;
      const paymentTokens = assetData?.collection?.payment_tokens;
      let newImgMap = [];
      if (paymentTokens && paymentTokens.length) {
        imgMap.forEach((item) => {
          let data = paymentTokens.filter(
            (tokenItem) => tokenItem.symbol === item.label
          );
          if (data.length) {
            newImgMap.push(item);
          }
        });
      }
      this.setState({
        assetData: assetData,
        sdkQuery: sdkQuery,
        curImageMap: newImgMap,
      });
      this.showModal();
    });
  }

  componentWillUnmount() {
    Emitter.removeListener("showSellModal", () => {});
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleCancel = (e) => {
    this.handleStepCancel();
    this.setState({
      priceHelp: null,
      priceStatus: null,
      price: null,
      dateHelp: null,
      dateStatus: null,
      date: null,
      cueCurrency: "TRX",
      visible: false,
    });
  };
  handlePriceChange = (val) => {
    let { intl } = this.props;
    let price = val;
    if (price.split(".")[1]) {
      if (price.split(".")[1].length > 4) {
        price = price.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/, "$1$2$3");
      }
    }
    this.setState({ price: price });
    if (price !== "" && price >= 100000000) {
      this.setState({
        priceStatus: "error",
        priceHelp: intl.formatMessage({ id: "price_error_3" }),
      });
    } else if (price < 1) {
      this.setState({
        priceStatus: "error",
        priceHelp: intl.formatMessage({ id: "price_error_1" }),
      });
    } else {
      this.setState({
        priceStatus: null,
        priceHelp: null,
      });
    }
  };
  getDateIsValid = (dateString) => {
    let { intl } = this.props;
    let time = new Date(dateString).getTime();
    console.log("time", time);
    let max = new Date(
      new Date().getTime() + 365 * 24 * 60 * 60 * 1000
    ).getTime();
    let min = new Date(new Date().getTime() + 10 * 60 * 1000).getTime();
    if (!Number.isNaN(time)) {
      if (time > min && time < max) {
        // setTimeValid(true);
        this.setState({
          dateStatus: null,
          dateHelp: null,
        });
      } else {
        this.setState({
          dateStatus: "error",
          dateHelp: intl.formatMessage({ id: "expiration_error_1" }),
        });
        return false;
      }
    } else {
      this.setState({
        dateStatus: "error",
        dateHelp: intl.formatMessage({ id: "expiration_error_1" }),
      });
      return false;
    }
    return true;
  };
  handleTimeChange = (dayjs, dateString) => {
    const dateIsValid = this.getDateIsValid(dateString);
    if (dateIsValid) {
      this.setState({ date: dateString });
    }
  };

  viewMetadata = async (contract, tokenID) => {
    if (contract) {
      let url = await getMetadata(contract.split("_")[2], tokenID);
      if (url.indexOf("https://gateway.btfs.io/btfs/") > -1) {
        window.open(url);
      } else {
        window.open("https://gateway.btfs.io/btfs/" + url);
      }
    }
  };
  handleList = async () => {
    const { price, date, cueCurrency, assetData, sdkQuery } = this.state;
    const dateIsValid = this.getDateIsValid(date);
    if (!dateIsValid) {
      return;
    }
    const { contractAddress, tokenId } = assetData;
    const data = await sdkQuery.getAssetDetail(contractAddress, tokenId);
    const isListed = data?.asks_v2?.length;
    if (isListed) {
      Emitter.emit("showMessageAlert", {
        message: "already_listed",
        status: "warning",
      });
      this.handleCancel();
      Emitter.emit("emitUpdateFile", {});
      return;
    }
    const sdkOrder = new APENFTOrders(window.tronWeb, apiConfig);
    const timestamp = new Date(date).getTime();
    const params = {
      collection: contractAddress,
      id: tokenId,
      price: Number(price),
      currency: cueCurrency,
      expirationTime: timestamp,
    };
    const orderParams = await sdkQuery.getFixPriceOrderParams(params);
    this.setState({ stepVisible: true });
    let orderType = "FixPriceOrder";
    try {
      await initApprove({
        APENFTOrders: sdkOrder,
        orderType: orderType,
        orderParams: orderParams,
      });
    } catch (error) {
      this.setStepError();
      return {
        error: error.message ? error.message : error,
      };
    }
    this.setState({ step: 1 });
    let result = null;
    try {
      result = await sdkOrder.createSellOrder(orderParams);
    } catch (error) {
      this.setStepError();
      return {
        error: error.message ? error.message : error,
      };
    }

    if (result && result.orderHash) {
      Emitter.emit("showMessageAlert", {
        message: "listing_successful",
        status: "success",
      });
      this.handleCancel();
      Emitter.emit("emitUpdateFile", {});
    } else {
      this.setStepError();
    }
  };
  setStepError = (param) => {
    this.setState({ stepError: true });
  };
  handleCurrencyChange = (value) => {
    this.setState({ cueCurrency: value });
  };
  handleRetryClick = () => {
    this.setState({ stepError: false, step: 0 });
    this.handleList();
  };
  handleStepCancel = () => {
    this.setState({ stepVisible: false, stepError: false, step: 0 });
  };

  render() {
    let {
      priceStatus,
      priceHelp,
      dateStatus,
      dateHelp,
      assetData,
      price,
      date,
      cueCurrency,
      step,
      stepVisible,
      stepError,
      visible,
      curImageMap,
    } = this.state;
    const { activeLanguage } = this.props;
    console.log("activeLanguage", activeLanguage);
    const RoyaltiesFeePer = toFixed(
      (parseInt(assetData?.collection?.royalty) * 100) / 10000,
      2
    );
    const RoyaltiesFee = toFixed(
      parseInt(assetData?.collection?.royalty) / 10000,
      4
    );
    const TotalPer = toFixed((window.serviceFee + RoyaltiesFee) * 100, 2);
    return (
      <div className="m-auto text-center">
        {visible && (
          <Modal
            visible={visible}
            maskClosable={false}
            centered={isMobile ? false : true}
            onCancel={this.handleCancel}
            footer={null}
            closeIcon={<i className="iconfont icon-guanbi"></i>}
            wrapClassName={"message_modal_sell"}
          >
            <div
              className="h-full w-full"
              style={{
                overflowX: "scroll",
                overflowY: "hidden",
                position: "relative",
              }}
            >
              <div className="sell-title">
                <strong>{t("sell_own")}</strong>
              </div>
              <div
                className="w-full flex justify-between"
                style={{ alignItems: "center" }}
              >
                <Form layout="vertical" autoComplete="off">
                  <Form.Item
                    required="true"
                    validateStatus={priceStatus}
                    help={priceHelp}
                    className="ant-form-item-1"
                  >
                    <label className="sell-label">
                      <span className="star-red">*</span>
                      {t("price")}
                    </label>
                    <Input.Group
                      compact
                      style={{
                        width: "300px",
                        height: "48px",
                        display: "flex",
                      }}
                    >
                      <Select
                        style={{ width: "120px" }}
                        defaultValue={cueCurrency}
                        popupClassName="price-select"
                        onChange={this.handleCurrencyChange}
                      >
                        {curImageMap.map((item) => {
                          return (
                            <Option
                              className="flex flex-row items-center price-option-item"
                              value={item.label}
                              key={item.label}
                            >
                              <img
                                alt=""
                                className="currency-item"
                                src={item.icon}
                              />
                              <span className="currency-label">
                                {item.label}
                              </span>
                            </Option>
                          );
                        })}
                      </Select>
                      <Input
                        style={{ flex: 1, width: "100%", height: "100%" }}
                        defaultValue={price}
                        value={price}
                        type="number"
                        onChange={(e) => {
                          this.handlePriceChange(e.target.value);
                        }}
                      />
                    </Input.Group>
                  </Form.Item>
                  <Form.Item
                    required="true"
                    validateStatus={dateStatus}
                    help={dateHelp}
                    className="ant-form-item-2"
                  >
                    <label className="sell-label">{t("expiration_date")}</label>
                    <DatePicker
                      allowClear={false}
                      locale={activeLanguage === "zh" ? zhCN : enUS}
                      format="YYYY-MM-DD HH:mm:ss"
                      showTime={{
                        defaultValue: dayjs("00:00:00", "HH:mm:ss"),
                      }}
                      onChange={this.handleTimeChange}
                      style={{
                        width: "300px",
                        height: "48px",
                      }}
                      okText={"hahaha"}
                    />
                  </Form.Item>
                </Form>
                <div className="asset-msg">
                  <img
                    className="m-0"
                    alt=""
                    style={{
                      width: "160px",
                      height: "160px",
                      objectFit: "contain",
                      borderRadius: "4px 4px 0 0",
                      backgroundColor: "#F7F7F7",
                    }}
                    src={`https://gateway.btfs.io/btfs/${assetData?.file_hash}`}
                  />
                  <div className="asset-name">{assetData?.name}</div>
                </div>
              </div>
              <div className="w-full">
                <div>
                  <label className="sell-label" style={{ marginBottom: "7px" }}>
                    {t("fees")}
                  </label>
                  <div className="fee-des">{t("fees_des")}</div>
                </div>
                <div className="fee-detail">
                  <div>
                    <div className="fee-item">
                      <div className="fee-label">{t("APENFT_service_fee")}</div>
                      <div className="fee-val">
                        {toFixed(window.serviceFee * 100, 2)} %
                      </div>
                    </div>
                    <div className="fee-item">
                      <div className="fee-label">{t("copyright_fee")}</div>
                      <div className="fee-val">{RoyaltiesFeePer} %</div>
                    </div>
                    <div className="fee-item">
                      <div className="fee-label">{t("total_fees")}</div>
                      <div className="fee-val">{TotalPer} %</div>
                    </div>
                  </div>
                  <img
                    className="fee-img"
                    src={Fee}
                    alt=""
                    width="96px"
                    height="87px"
                  />
                </div>
              </div>
              <div className="list-btn-bottom">
                <Button
                  className="list-btn"
                  disabled={
                    priceStatus === "error" ||
                    dateStatus === "error" ||
                    !price ||
                    !date
                  }
                  onClick={this.handleList}
                >
                  {t("listing_btn")}
                </Button>
              </div>
            </div>
          </Modal>
        )}

        <StepModal
          handleRetryClick={this.handleRetryClick}
          step={step}
          visible={stepVisible}
          stepError={stepError}
          handleCancel={this.handleStepCancel}
        ></StepModal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentAccount: state.app.currentAccount,
  };
}

const mapDispatchToProps = {
  setAccount,
  setChain,
  setBalance,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(SellModal));
